import ApiService from 'utils/ApiCalls';
import { useSelector } from 'react-redux';
import { notification } from 'antd';
import axios from 'axios';

const useFetchICTServices = () => {
  const {
    selectedContractForICT,
    selectedEntityForICT,
    selectedFunctionForICT,
    selectedTPPForICT,
  } = useSelector((state: any) => state.ictServices);

  const fetchICTServices = async () => {
    try {
      const response = await ApiService.fetchICTServices(
        selectedContractForICT,
        selectedEntityForICT,
        selectedFunctionForICT,
        selectedTPPForICT,
      );
      return response;
    } catch (error) {
      console.log('Error fetching ICT Services:', error);
      throw error;
    }
  };

  return fetchICTServices;
};

const useFetchICTServicesForData = () => {
  const { selectedEntityForICT } = useSelector(
    (state: any) => state.ictServices,
  );
  const { selectedICTForContractualInformation } = useSelector(
    (state: any) => state.contractualInformation,
  );

  const fetchICTServicesForData = async () => {
    try {
      const response = await ApiService.fetchDataWithICT(
        selectedEntityForICT,
        selectedICTForContractualInformation,
      );
      return response;
    } catch (error) {
      console.log('Error fetching ICT Services for Data:', error);
      throw error;
    }
  };

  return fetchICTServicesForData;
};

const useFetchFunctionsForData = () => {
  const { selectedEntityForICT, selectedFunctionForICT } = useSelector(
    (state: any) => state.ictServices,
  );

  const fetchFunctionsForData = async () => {
    try {
      const response = await ApiService.fetchDataWithFunctions(
        selectedEntityForICT,
        selectedFunctionForICT,
      );
      return response;
    } catch (error) {
      console.log('Error fetching Functions for Data:', error);
      throw error;
    }
  };

  return fetchFunctionsForData;
};

const postICTServices = async (ICTServices: any) => {
  try {
    const response = await ApiService.postICTServices(ICTServices);
    notification.success({
      message: 'Info',
      description: 'The data was successfully submitted.',
      placement: 'topRight',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchFunctionsbyEntityName = async (entityTypeData: any) => {
  try {
    const response = await ApiService.postFunctionsbyEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the Functions:', error);
  }
};

const fetchContractualArrangementsbyEntityName = async (
  entityTypeData: any,
) => {
  try {
    const response =
      await ApiService.postContractualArrangementsbyEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the Contractual Arrangements:', error);
  }
};

const fetchICTServiceTypes = async () => {
  try {
    const response = await ApiService.getICTServiceTypes();
    return response;
  } catch (error) {
    console.log('Error fetching the ict service types:', error);
  }
};

const fetchLevelsOfReliance = async () => {
  try {
    const response = await ApiService.getLevelsOfReliance();
    return response;
  } catch (error) {
    console.log('Error fetching the levels of reliance', error);
  }
};

const fetchCriticalityAssessments = async () => {
  try {
    const response = await ApiService.getCriticalityAssessments();
    return response;
  } catch (error) {
    console.log('Error fetching the criticality assessments', error);
  }
};

const fetchDoraCriticality = async () => {
  try {
    const response = await ApiService.getDoraCriticality();
    return response;
  } catch (error) {
    console.log('Error fetching the dora criticality', error);
  }
};

const fetchReintegrationPossibilities = async (entity_id: any) => {
  try {
    const response = await ApiService.getReintegrationPossibilities(entity_id);
    return response;
  } catch (error) {
    console.log('Error fetching the reintegration possibilities', error);
  }
};

const fetchImpactOfDiscontinuingICTServices = async (entity_id: any) => {
  try {
    const response =
      await ApiService.getImpactOfDiscontinuingICTServices(entity_id);
    return response;
  } catch (error) {
    console.log(
      'Error fetching the impact of discontinuing ICT Services',
      error,
    );
  }
};

const fetchAlternativesExit = async () => {
  try {
    const response = await ApiService.getAlternativesExit();
    return response;
  } catch (error) {
    console.log('Error fetching the alternatives exit', error);
  }
};

const fetchICTLevels = async () => {
  try {
    const response = await ApiService.getICTLevels();
    return response;
  } catch (error) {
    console.log('Error fetching the ict levels', error);
  }
};

const fetchSupportLevel = async () => {
  try {
    const response = await ApiService.getSupportLevel();
    return response;
  } catch (error) {
    console.log('Error fetching the support level', error);
  }
};

const fetchYesNo = async () => {
  try {
    const response = await ApiService.getYesNo();
    return response;
  } catch (error) {
    console.log('Error fetching the yes/no', error);
  }
};

const fetchICTServicesCriticality = async () => {
  try {
    const response = await ApiService.getICTServicesCriticality();
    return response;
  } catch (error) {
    console.log('Error fetching the ict service criticality', error);
  }
};

const fetchLocalRegulatorCriticality = async () => {
  try {
    const response = await ApiService.getLocalRegulatorCriticality();
    return response;
  } catch (error) {
    console.log('Error fetching the local regulator criticality', error);
  }
};

const fetchICTSystemsCategoryICTServicesbyEntityName = async (
  entityTypeData: any,
) => {
  try {
    const response =
      await ApiService.postICTSystemsByEntityCategoryICTService(entityTypeData);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log(
        'Error fetching ICT Systems:',
        error.response?.data || error.message,
      );
    } else {
      console.log('An unexpected error occurred:', error);
    }
    throw error;
  }
};

export default {
  useFetchICTServices,
  fetchFunctionsbyEntityName,
  fetchContractualArrangementsbyEntityName,
  postICTServices,
  fetchICTServiceTypes,
  fetchLevelsOfReliance,
  fetchCriticalityAssessments,
  fetchReintegrationPossibilities,
  fetchImpactOfDiscontinuingICTServices,
  fetchAlternativesExit,
  fetchICTLevels,
  fetchSupportLevel,
  fetchYesNo,
  fetchICTServicesCriticality,
  fetchLocalRegulatorCriticality,
  fetchDoraCriticality,
  useFetchICTServicesForData,
  useFetchFunctionsForData,
  fetchICTSystemsCategoryICTServicesbyEntityName,
};
